//
//  GoogleHealthAccountLinkageComplete.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { type ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import IsnLogo from "../component/IsnLogo";

const GoogleHealthAccountLinkageComplete = (): ReactElement => {
  return (
    <>
      <IsnLogo />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 10,
          gap: 3,
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "success.main" }} />
        <Typography variant="h5" fontWeight="bold" textAlign="center">
          連携が完了しました
        </Typography>
        <Typography color="text.secondary" textAlign="center">
          Google HealthのデータをFITINSIGHTに同期する設定が完了しました。
        </Typography>
        <Typography color="text.secondary">
          このページを閉じてください。
        </Typography>
      </Box>
    </>
  );
};

export default GoogleHealthAccountLinkageComplete;
